// Поиск по строке: текст без учёта регистра, телефон по цифрам. «+380987979839», «098 797 98 39»
// и «+380 98 797» находят один и тот же номер, как бы он ни был записан в базе.

export const digitsOf = (value) => String(value === null || value === undefined ? '' : value).replace(/\D/g, '');

// Запрос похож на номер: только цифры, пробелы, плюс, скобки и дефисы.
const PHONE_LIKE = /^[\d\s+()-]+$/;

// texts — где искать как текст; phones — где искать по цифрам.
export const matchesSearch = (query, texts = [], phones = []) => {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return true;
  const asText = texts.some((text) =>
    String(text === null || text === undefined ? '' : text).toLowerCase().includes(needle)
  );
  if (asText) return true;
  const digits = digitsOf(needle);
  return digits.length > 0 && PHONE_LIKE.test(needle) && phones.some((phone) => digitsOf(phone).includes(digits));
};
